export function getAccessMode(settings) {
  return settings?.private_access === false ? "group" : "individual";
}

export function getAccessLabel(settings) {
  return getAccessMode(settings) === "group" ? "Групповой" : "Индивидуальный";
}

export function getGroupShareLink(gameId) {
  const botName = (process.env.REACT_APP_BOT_NAME || "@MoGame_bot").replace(
    /^@/,
    ""
  );
  return `https://t.me/${botName}?start=${gameId}`;
}

export function getProjectStatusFromSettings(gameSettings) {
  if (gameSettings?.hidden) return "hidden";
  if (gameSettings?.published) return "published";
  return "draft";
}

export function settingsFromProjectStatus(projectStatus) {
  return {
    published: projectStatus === "published",
    hidden: projectStatus === "hidden",
  };
}

export function getProjectStatusDisplay(settings) {
  if (settings?.hidden) {
    return { label: "Остановлен", tone: "stopped" };
  }
  if (settings?.published) {
    return { label: "Опубликован", tone: "published" };
  }
  return { label: "В работе", tone: "draft" };
}

export const ACCESS_MODE_HINTS = {
  individual:
    "Доступ получит только пользователь с ключом. После активации ключ станет недействителен.",
  group:
    "Доступ получат все, у кого есть ссылка. Нужна активная бизнес-подписка по размеру команды.",
};

export const EXAMPLE_START_POST = {
  title: "Долг платежом красен",
  description:
    "Привет! Ты готов начать увлекательное приключение со мной?",
  posterSrc: `${process.env.PUBLIC_URL}/images/bg.png`,
};
